module.exports = __webpack_public_path__ + "img/scene5-14.e250c98f.png";